import useAnswerFeedback from './useAnswerFeedback.hook';
import { StyledAnswerFeedback } from './AnswerFeedback.styled';
import { useContext } from 'react';
import { GameLoopContext } from '@/shared/GameComponents/GameLoopContext/GameLoopContext';
import { GameAssetsContext } from '@/shared/GameComponents/GameAssetsContext/GameAssetsContext';

export default function AnswerFeedback({}) {
  const game = useContext(GameLoopContext);
  const { state: assets } = useContext(GameAssetsContext);
  useAnswerFeedback({ game, assets });

  const isRightAnswer =
    game.state.currentAnswerId == game.state.currentConcept.id;
  const showRightAnswer = !game.state.currentAnswerId || !isRightAnswer;

  return (
    <StyledAnswerFeedback>
      <div className="feedback">
        <>
          {game.state.currentAnswerId ? (
            isRightAnswer ? (
              <></>
            ) : (
              <>
                That's not correct! The right answer is:
                <br />
              </>
            )
          ) : (
            <>
              Time is up! The right answer is:
              <br />
            </>
          )}
        </>
      </div>
      {showRightAnswer && (
        <p className="right-answer">{game.state.currentConcept.text}</p>
      )}
    </StyledAnswerFeedback>
  );
}
